<template>
  <div :class="'documents-block ' + 'documents' + group">
    <preloader :visible="preloader" />
    <v-server-table ref="vuetable" :url="route" :columns="columns" :options="options" @loading="onLoading" @loaded="onLoaded"  class="custom-table-modifier">
      <div slot="size" slot-scope="props_data" v-html="props_data.row.size"></div>
      <div slot="user" slot-scope="props_data" v-html="props_data.row.user.name"></div>
      <div slot="actions" slot-scope="props_data">
        <a href="#" class="mr-2 mb-2 btn btn-sm btn-danger"  v-on:click="tryDelete(props_data.row.id)" v-if="isAdmin || props_data.row.user_id === user.id">Delete</a>
        <a :href="`/document/${props_data.row.id}/download`" class="mr-2 mb-2 btn btn-sm btn-success custom-btn-loader">Download</a>
      </div>
    </v-server-table>
  </div>
</template>

<script>
import Preloader from "./blocks/preloader";
export default {
  components: { Preloader },
  props: {
    route: {
      type: String
    },
    group: {
      type: Number
    },
    user: {},
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      preloader: false,
      columns: [ 'created_at', 'user', 'source_name', 'size', 'actions'],
      options: {
        filterByColumn: true,
        debounce: 1000,
        requestFunction: (data) => {
          return axios.get(this.route, { params: data });
        },
        orderBy: {
          ascending: false,
        },
        dateColumns: [ 'created_at' ],
        dateFormat: 'YYYY-MM-DD',
        datepickerOptions: {
          showDropdowns: true,
          autoUpdateInput: true,
        },
        perPage: 30,
        pagination: {
          chunk:30,
          dropdown:false
        },
        sortable: [],
        filterable: [ 'created_at', 'user', 'source_name'],
        headings: {
          created_at: 'Created',
          user: 'Technician',
          source_name: 'Name',
          size: 'Size',
          actions: 'Actions',
        }
      }
    }

  },
  methods: {
    onLoading(e) {
      this.preloader = true;
    },
    onLoaded(e) {
      this.preloader = false;
    },

    tryDelete(documentId) {
      this.$swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this document!',
        icon: 'warning',
        confirmButtonText: 'Delete',
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteDocument(documentId);
        }
      });
    },
    deleteDocument(id) {
      const self = this;
      axios.post(`/document/${id}/delete`).then(response => {
        if (response.data.error) {
          self.toast(response.data.error, 'error');
        } else {
          self.toast(response.data.success);
          this.$refs.vuetable.getData()
        }
      }).catch(e => {
        console.log(e);
        self.toast('Document was not deleted because of error.', 'error');
      });
    },

    toast(message, type) {
      const self = this.$swal;
      self.fire({
        text: message,
        icon: type || 'success',
        toast: true,
        showConfirmButton: false,
        position: 'top-end',
        timer: 1500,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', self.stopTimer)
          toast.addEventListener('mouseleave', self.resumeTimer)
        }
      });
    }
  }
}
</script>